import { getIndex } from '../helpers.js';
import { statsOnWidgetInteraction } from '../stats.js';

export const accordionVertical = () => {
  const onAnimationFinish = (el, open) => {
    el.animation = null;
    el.isClosing = false;
    el.isExpanding = false;
    el.open = open;
    el.style.height = el.style.overflow = '';
  };

  const expand = (el, summary, content) => {
    el.isExpanding = true;
    const startHeight = `${el.offsetHeight}px`;
    const endHeight = `${summary.offsetHeight + content.scrollHeight}px`;
    if (el.animation) {
      el.animation.cancel();
    }

    el.animation = el.animate({
      height: [startHeight, endHeight],
    }, {
      duration: 400,
      easing: 'ease-out',
    });
    el.animation.onfinish = () => onAnimationFinish(el, true);
    el.animation.oncancel = () => el.isExpanding = false;
  };

  const shrink = (el, summary) => {
    el.isClosing = true;
    const startHeight = `${el.offsetHeight}px`;
    const endHeight = `${summary.offsetHeight}px`;
    if (el.animation) {
      el.animation.cancel();
    }

    el.animation = el.animate({
      height: [startHeight, endHeight],
    }, {
      duration: 400,
      easing: 'ease-out',
    });

    el.animation.onfinish = () => onAnimationFinish(el, false);
    el.animation.oncancel = () => el.isClosing = false;
  };

  const closeAllAccordionsExcept = (currentEl, accordion) => {
    accordion.querySelectorAll('details[open]').forEach((openEl) => {
      if (openEl !== currentEl) {
        openEl.classList.remove('details--open');
        const summary = openEl.querySelector('summary');
        shrink(openEl, summary);
      }
    });
  };

  const setupAccordion = (el) => {
    const summary = el.querySelector('summary');
    const content = el.querySelector('.content');
    let activeIndex = 0;
    el.animation = null;
    el.isClosing = false;
    el.isExpanding = false;

    const onClickOpen = (e) => {
      e.preventDefault();
      el.style.overflow = 'hidden';
      if (el.isClosing || !el.open) {
        el.classList.add('details--open');
        closeAllAccordionsExcept(el, el.closest('.accordion-vertical'));
        el.style.height = `${el.offsetHeight}px`;
        el.open = true;
        window.requestAnimationFrame(() => expand(el, summary, content));
        activeIndex = getIndex(el) + 1;
        const image = el.closest('.section__columns').querySelector('.images__wrapper').querySelector('img');
        image.classList.remove('img--visible');
        const newSrc = `https://bestfolio.wpcdn.pl/img/whatwedo/${activeIndex}.webp`;
        const preloadedImage = new Image();
        preloadedImage.src = newSrc;
        preloadedImage.onload = () => {
          image.src = newSrc;
          image.classList.add('img--visible');
        };
      }
      statsOnWidgetInteraction(el, el.querySelector('summary').innerText);
      // else if (el.isExpanding || el.open) {
      //   el.classList.remove('details--open');
      //   shrink(el, summary);
      // }
    };

    summary.addEventListener('mouseenter', onClickOpen);
  };

  document.querySelectorAll('details').forEach((el) => {
    setupAccordion(el);
  });
};
